import { getLinkedWPQBySK, addWPQLinkingRecord, getWPQLinkingRecords } from "../../Services/WI-services"

export const getLinkedWPQRecords = async (skString, jtType) => {
    let linkedWPQs = [];
    let skArray = skString?.split(",");
    for (let i = 0; i < skArray.length; i = i + 100) {
        let skString = skArray.slice(i, i + 100).join(",");
        let wpqResult = await getLinkedWPQBySK({ WI_WPQ_Data: skString, WI_Joint_Type: jtType });
        linkedWPQs.push(...wpqResult);
    }
    return linkedWPQs;
}


export const addWPQLinkingData = async (selectedWPQ, wiObj) => {
    const chunkSize = 200;
    let addResult;
    let srNo = 1;

    for (let i = 0; i < selectedWPQ.length; i += chunkSize) {
        let newWiObj = {
            PK: wiObj.PK,
            SK: wiObj.SK + "#WPQ#" + srNo,
            WI_WPQ_Data: selectedWPQ.slice(i, i + chunkSize).join(","),
        }
        addResult = await addWPQLinkingRecord(newWiObj);
        srNo++;
    }
    return addResult;
}

export const getWPQLinkingData = async (wiObj) => {
    let linkingData = [];
    let dataObj = {
        PK: wiObj.PK,
        SK: wiObj.SK
    }
    let result = await getWPQLinkingRecords(dataObj);
    if (result?.length > 0) {
        linkingData = result.map(obj => obj.WI_WPQ_Data.split(',')).flat();
    }
    return linkingData;
}